<script setup lang="ts">
import useAuthentication from '~/composables/useAuthentication'
import { useReports } from '~/composables/useReports'
import { ALL_MARKETS, NEW_TECHNOLOGY } from '~/constants/services/constants'
import { MARKET_TYPE } from '~/src/constants/markets'
import type { TMarketSlug } from '~/src/types/markets'

import ReportList from '~/components/critical-insights/ReportList.vue'

const { getReportAndModelData } = useReports()

const market = computed(() =>
  ALL_MARKETS.find((m) => m.slug === NEW_TECHNOLOGY.slug),
)
const marketName = computed(() => market.value?.name)

const { status, data, refresh } = useAsyncData(
  async () => {
    const reports = await getReportAndModelData(
      NEW_TECHNOLOGY.slug as TMarketSlug,
      [MARKET_TYPE.CRITICAL_INSIGHTS],
      true,
      -1,
    )
    return { reports }
  },
  {
    lazy: true,
    default: () => ({ reports: [] }),
  },
)

useAuthentication(() => refresh())

const reports = computed(() => data.value?.reports)
const isLoading = computed(() => status.value === 'pending')

definePageMeta({ isTab: true, layout: 'services' })
</script>

<template>
  <TheLoader v-if="isLoading" />
  <ReportList v-else :reports="reports" :market="marketName" />
</template>
